import { BTN_RESET_CLASS } from '../constants';
import TimeNyangActionChip from './TimeNyangActionChip';
import TITLE_UNDERLINE_IMAGE from '../../../assets/images/time-nyang/title-underline.svg';
import HEADER_ARROW_IMAGE from '../../../assets/images/time-nyang/header-arrow.svg';
import FREE_PLAY_ICON from '../../../assets/images/time-nyang/free-play-icon.svg';
import BOOSTER_ICON from '../../../assets/images/time-nyang/booster-icon.svg';

export function TimeNyangTopBar({ onBack, onOpenGuide }) {
  return (
    <header className="absolute left-0 right-0 z-20 flex h-[46px] items-center justify-between px-2.5">
      <button type="button" aria-label="뒤로가기" onClick={onBack} className={`${BTN_RESET_CLASS} rounded p-1`}>
        <img src={HEADER_ARROW_IMAGE} alt="" className="h-5 w-5" />
      </button>
      <button
        type="button"
        className={`${BTN_RESET_CLASS} pr-1 font-['Pretendard'] text-sm font-bold text-white`}
        onClick={onOpenGuide}
      >
        안내
      </button>
    </header>
  );
}

export default function TimeNyangHeader({
  freePlayCountText,
  boosterCountText,
  onFreePlayClick,
  onBoosterClick,
  isFreePlayActive,
  freePlayCooldownLabel,
  isFreePlayDisabled,
  isFreePlayLoading = false,
  boosterStatusLabel,
  isBoosterDisabled,
  isBoosterLoading = false,
}) {
  return (
    <>
      <section className="flex items-start justify-between px-4">
        <div>
          <h1 className="font-['Pretendard'] text-[30px] font-bold leading-[1.3] tracking-[-0.5px] text-white">
            <span className="text-[#F9BAAC]">타임냥</span> 챌린지
            <br />
            3.23초
          </h1>
          <p className="-mb-1 mt-3 font-['Pretendard'] text-xs font-bold tracking-[-0.5px] text-white">
            찰나의 순간, 타이밍을 지배하냥 !
          </p>
          <img src={TITLE_UNDERLINE_IMAGE} alt="" className="h-[4px] w-[185px]" />
        </div>
        <div className="flex gap-2">
          <div className="flex flex-col items-center">
            <TimeNyangActionChip
              label="무료탐냥"
              count={freePlayCountText}
              statusLabel={isFreePlayLoading ? '로딩 중' : freePlayCooldownLabel}
              icon={FREE_PLAY_ICON}
              onClick={onFreePlayClick}
              isActive={isFreePlayActive}
              disabled={isFreePlayDisabled}
            />
          </div>
          <div className="flex flex-col items-center">
            <TimeNyangActionChip
              label="적립부스터"
              count={boosterCountText}
              statusLabel={isBoosterLoading ? '로딩 중' : boosterStatusLabel}
              icon={BOOSTER_ICON}
              dark
              onClick={onBoosterClick}
              disabled={isBoosterDisabled}
            />
          </div>
        </div>
      </section>
    </>
  );
}
